import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  plainText: string = "";
  encryptText: string = "";
  decPassword: string = "";
  conversionEncryptOutput: any;
  conversionDecryptOutput: any;
  iv = CryptoJS.enc.Utf8.parse('F5B9E7EC63B8A1F5');
  key = CryptoJS.enc.Utf8.parse('F5B9E7EC63B8A1F5');

  constructor() { }

  //method is used to encrypt and decrypt the text  
  convertText(conversion: string, encRequest: HttpRequest<any>) {
    if (encRequest.method.toLowerCase() === 'get') {
      if (encRequest.url.includes('getUnRegisteredTemplate') != true) {
        if (encRequest.url.includes('?') && !encRequest.url.includes('&')) {
          const params = encRequest.url.split('?');
          let encodeUrl = params[0] + '?';
          let encodedParams: any = '';
          params.forEach((param, i) => {
            let keyValue = param.split('=');
            if (i !== 0 && keyValue[1] !== '') {
              encodedParams += keyValue[0] + '=' + this.encryptPayload(encodeURIComponent(keyValue[1]))
            } else if (i !== 0 && (keyValue[1] == '' || keyValue[1] == undefined)) {
              encodedParams = param;
            }
          })
          this.conversionEncryptOutput = encRequest.clone({ url: encodeUrl + encodedParams })
         } else {
          this.conversionEncryptOutput = encRequest
        }
      } else {
        this.conversionEncryptOutput = encRequest
      }
    } else if (encRequest.method.toLocaleLowerCase() === 'post') {
      if (encRequest.body) {
        const hasFormData: any = encRequest.body instanceof FormData
        if (hasFormData) {
          const modifiedFormData = new FormData();
          for (const pair of encRequest.body.entries()) {
            modifiedFormData.append(pair[0], (pair[0] == 'files' || pair[0] == 'file') ? pair[1] : this.encryptPayloadPost(pair[1]));
          }
          this.conversionEncryptOutput = encRequest.clone({ body: modifiedFormData })
        } else {
          const request = this.encryptPayloadPost(JSON.stringify(encRequest.body))
          this.conversionEncryptOutput = encRequest.clone({ body: { request: request } })
        }
      } else{
        this.conversionEncryptOutput = encRequest;
      }
    }
    return this.conversionEncryptOutput;
  }

encryptPayload(payload:any){
  var encrypted = CryptoJS.AES.encrypt(payload?.toString().trim(), this.key, { iv: this.iv, mode: CryptoJS.mode.CBC});
  return encodeURIComponent(encrypted.toString());
}

encryptPayloadPost(payload:any){
  var encrypted = CryptoJS.AES.encrypt(payload?.toString().trim(), this.key, { iv: this.iv, mode: CryptoJS.mode.CBC});
  return encrypted.toString()
}

  decryptResponse(response: any) {
    var decrypted: any;
    if (response?.error?.response) {
      decrypted = CryptoJS.AES.decrypt(response?.error?.response.trim(), this.key, { iv: this.iv, mode: CryptoJS.mode.CBC });
      this.conversionDecryptOutput = JSON.parse(decrypted?.toString(CryptoJS.enc.Utf8));
    } else if (response?.body?.response) {
      decrypted = CryptoJS.AES.decrypt(response?.body?.response.trim(), this.key, { iv: this.iv, mode: CryptoJS.mode.CBC });
      this.conversionDecryptOutput = JSON.parse(decrypted?.toString(CryptoJS.enc.Utf8));
    } else{
      this.conversionDecryptOutput = {}
    }
    return this.conversionDecryptOutput
  }
}
